module.exports = __webpack_public_path__ + "img/2015-05-02.edae4e5e.jpg";